import {
  Box,
  Skeleton,
  SkeletonProps,
  useBreakpointValue,
} from '@chakra-ui/react';
import React from 'react';

export const SkeletonColored: React.FC<SkeletonProps> = ({
  startColor = 'primary.50',
  endColor = 'primary.100',
  borderRadius = 'lg',
  ...props
}) => {
  return (
    <Skeleton
      startColor={startColor}
      endColor={endColor}
      borderRadius={borderRadius}
      {...props}
    />
  );
};

export const StackCreatorSkeleton = () => {
  const skeletonCount = useBreakpointValue({ base: 1, md: 2, lg: 3, xl: 4 });
  return (
    <Box p={6}>
      <Box display="flex" flexDir={['column', 'column', 'row']}>
        <Box
          maxWidth={{ base: '100%', md: '40%' }}
          marginRight="4"
          marginBottom="5"
        >
          <Box display="flex" justifyContent="space-between">
            <SkeletonColored
              boxSize={{ base: '120px', lg: '150px' }}
              marginRight={1}
            />
            <SkeletonColored
              flex="1"
              h="6"
              maxWidth="64"
              marginBottom="2"
              display={{ base: 'block', md: 'none' }}
            />
          </Box>
          <SkeletonColored mt="4" h="24px" width="100%" maxW="32" />
        </Box>
        <Box flex="1">
          <Box display="flex" justifyContent={'space-between'}>
            <SkeletonColored
              flex="2"
              maxWidth="507px"
              h="14"
              marginBottom="2"
              marginRight="1"
            />
            <SkeletonColored
              flex="1"
              h="6"
              maxWidth="64"
              marginBottom="2"
              display={{ base: 'none', md: 'block' }}
            />
          </Box>
          <SkeletonColored maxWidth="700px" h="56px" marginBottom="2" />
        </Box>
      </Box>
      <Box display="flex" flexWrap="wrap">
        {Array(skeletonCount)
          .fill(0)
          .map((_, i) => (
            <SkeletonColored
              key={i}
              h="370px"
              width={{
                base: '100%',
                md: i % 2 === 0 ? '40%' : '45%',
                lg: i % 2 === 0 ? '220px' : '370px',
              }}
              marginBottom="4"
              marginRight={
                i === (skeletonCount as number) - 1 ? 0 : { base: '0', md: '2' }
              }
            />
          ))}
      </Box>
    </Box>
  );
};
